import { useEffect, useState } from "react"
import { useInView } from 'react-intersection-observer'
import { fetchAssistantAssociation, fetchAssistants, fetchContent, fetchContents, fetchKnowledgeBase, fetchTagResource, fetchUnTagResource } from "../../utils/apiUtils"
import Select from 'react-select';
import { useQuery, useInfiniteQuery, useMutation } from '@tanstack/react-query';
import SharedTable from "../benefitPlan/SharedTable";
import { queryClient } from "../../App";

const QInConnect = () => {
    const [selectedAssistant, setSelectedAssistant] = useState(null)
    const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState(null)
    const [showMoreColumns, setShowMoreColumns] = useState(false);

    const { ref, inView } = useInView()

    const { data: assistantOptions } = useQuery({
        queryKey: ['fetchAssistants'],
        queryFn: async () => await fetchAssistants({}),
        select: (data) => data.assistantSummaries
            .map((additional, i) => ({
                value: additional.assistantId,
                label: `${additional.name}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                additional,
            })),
        enabled: true
    })

    const getKnowlegdeBaseFromAssociation = async (assoc) => {
        const result = await fetchKnowledgeBase({ knowledgeBaseId: assoc?.associationData?.knowledgeBaseAssociation?.knowledgeBaseId })
        return { ...assoc, knowledgeBase: result.knowledgeBase }
    };

    const { data: knowledgeBaseOptions } = useQuery({
        queryKey: ['fetchAssistantAssociation', selectedAssistant?.value],
        queryFn: async () => {
            const assosiactions = await fetchAssistantAssociation({
                assistantId: selectedAssistant?.value
            })

            const tasks = assosiactions.assistantAssociationSummaries
                ?.filter(a => a.associationType === 'KNOWLEDGE_BASE')
                ?.map(assoc => getKnowlegdeBaseFromAssociation(assoc))

            const resutls = await Promise.all(tasks)

            return resutls
        },
        select: (data) => data
            .map((additional, i) => {
                return {
                    value: additional?.knowledgeBase?.knowledgeBaseId,
                    label: `${additional?.knowledgeBase?.name} `, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                    additional,
                }
            }),
        enabled: !!selectedAssistant
    })

    const queryKey = ['fetchContents', selectedAssistant, selectedKnowledgeBase]
    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,
        isSuccess,
        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = {
                knowledgeBaseId: selectedKnowledgeBase?.value,
                nextToken: pageParam
            };
            return fetchContents(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.contentSummaries).flatMap((x) => x),
                pageParams: data.pageParams,
            };
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.nextToken
        },

        staleTime: 0,//,Infinity,
        enabled: !!(selectedAssistant && selectedKnowledgeBase)
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);


    const updateTags = async (body) => {
        if (body.tagsKeysToRemove?.length) {
            await fetchUnTagResource({
                resourceArn: body.resourceArn,
                tagKeys: body.tagsKeysToRemove
            })
        }

        return await fetchTagResource({
            resourceArn: body.resourceArn,
            tags: body.tags
        })
    }

    const tagResourceoMutation = useMutation({
        mutationFn: updateTags,
        onSuccess: (data, variables) => {

            if (!data) return

            queryClient.setQueryData(queryKey, (oldData => {
                if (oldData) {
                    for (let i = 0; i < oldData.pages.length; i++) {
                        let page = oldData.pages[i];
                        page.contentSummaries = page.contentSummaries.map((item) => {
                            if (item.contentArn === variables.resourceArn) {
                                item = { ...item, tags: variables.tags }
                            }
                            return item;
                        });

                        oldData.pages[i] = page;
                    }
                }
                return oldData
            }));
        },
        onError: (err) => {
            console.log(err)
            // setError(err?.response?.data?.message || err.message)
        }
    })


    const onDetailHandler = async (body) => {
        const result = await fetchContent({
            contentId: body.contentId,
            knowledgeBaseId: body.knowledgeBaseId
        })
        return result.content
    }

    let columns = [`metadata['s3.object.key']`, `metadata['s3.object.size']`, 'contentType', 'tags'];

    if (showMoreColumns) {
        columns = [
            'title',
            `metadata['s3.bucket.name']`,
            ...columns,

        ];
    }

    const results = data?.pages.flat()

    return (
        <div className={'container '}>
            <p className='title'>Q In Connect</p>

            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', padding: '1rem 0rem' }}>

                <Select
                    name={'Domain'}
                    className="react-select-container large-input"
                    classNamePrefix="react-select"
                    placeholder={'domain...'}
                    options={assistantOptions}
                    value={selectedAssistant}
                    onChange={(opt) => setSelectedAssistant(opt)}
                />

                {knowledgeBaseOptions && <Select
                    name={'knowledgeBase'}
                    className="react-select-container large-input"
                    classNamePrefix="react-select"
                    placeholder={'knowledgeBase...'}
                    options={knowledgeBaseOptions}
                    value={selectedKnowledgeBase}
                    onChange={(opt) => setSelectedKnowledgeBase(opt)}
                />}

            </div>


            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSelectedAssistant(null)
                        setSelectedKnowledgeBase("");
                    }}
                >
                    Clear filters
                </p>

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>

            </div>

            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : isSuccess ? (
                <>
                    <SharedTable
                        type={"q-connect"}
                        columns={columns}
                        items={results}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        //  onDetailHandler={onDetailHandler}
                        tagResourceoMutation={tagResourceoMutation}
                        ref={ref}
                    />
                </>
            ) : <></>}
        </div >
    )
}

export default QInConnect